import { ExtraErrorData as ExtraErrorDataIntegration } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { environment } from 'folio-common-web-utils';
const release = 
// @ts-expect-error: COMMIT_SHA is injected by webpack
'NO_COMMIT' !== COMMIT_SHA ? COMMIT_SHA : undefined;
export function setupSentry(dsn) {
    Sentry.init({
        dsn,
        enabled: environment !== 'e2e',
        environment,
        release,
        integrations: integrations => integrations.concat(new ExtraErrorDataIntegration({ depth: 10 })),
        normalizeDepth: 11,
        beforeSend(event, hint) {
            if (environment === 'local') {
                const message = hint
                    ? hint.originalException || hint.syntheticException
                    : event.message;
                if (event.level === 'fatal' || event.level === 'error') {
                    // eslint-disable-next-line no-console
                    console.error(message);
                }
                else {
                    // eslint-disable-next-line no-console
                    console.log(message);
                }
                // this drops the event and nothing will be sent to Sentry
                return null;
            }
            return event;
        },
        beforeBreadcrumb(breadcrumb) {
            var _a;
            if ((breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') &&
                ((_a = breadcrumb.data) === null || _a === void 0 ? void 0 : _a.url)) {
                const { url } = breadcrumb.data;
                if (
                // they are not useful since they don't include the query. We have a custom one instead
                url.endsWith('/graphql')) {
                    return null;
                }
            }
            return breadcrumb;
        },
    });
}
//# sourceMappingURL=index.js.map